import React from "react";
import {Box, Typography,} from "@mui/material";

export default function FlatDpe({values, labels, colors, classe}) {
    const [barData, setBarData] = React.useState(undefined);
    const [n, setN] = React.useState(0);
    React.useEffect(() => {

        if (values && values.length > 0) {
            let tmp = {};
            let n = 0;
            Object.keys(values).forEach((key) => {
                let val = null
                if (classe && values[key][classe]) {
                    val = values[key][classe];
                }
                if (!val) {
                    val = values[key].classe_bilan_dpe;
                }
                if (!val) {
                    val = values[key].classe_conso_energie;
                }
                if (!val) {
                    val = values[key].classe_conso_energie_arrete_2012;
                }
                if (!val) {
                    val = values[key]["Etiquette_DPE"];
                }
                if (val) {
                    if (!tmp[val]) {
                        let idx = labels.findIndex((l) => l === val);
                        tmp[val] = {
                            label: val,
                            color: colors[idx],
                            nb: 0
                        }
                    }
                    tmp[val].nb++;
                    n++;
                }
            })

            let res = Object.keys(tmp).sort((key, key2) => {
                return key > key2 ? 1 : -1;
            })
            let tmp2 = {}
            res.forEach((key) => {
                tmp2[key] = tmp[key]
            })
            const ordered = Object.keys(tmp2).sort().reduce(
                (obj, key) => {
                    obj[key] = tmp2[key];
                    return obj;
                },
                {}
            );
            setN(n);
            setBarData(ordered)
        }
    }, [values])

    function getPercent(nb) {
        return (nb / n * 100) + "%";
    }

    return (<Box sx={{width: "95%", display: "flex", m: 1}}>
            {barData && Object.keys(barData).length > 0 && Object.keys(barData).map((key, index) => {
                return (
                    <Box key={index}
                         sx={{
                             width: getPercent(barData[key].nb),
                             backgroundColor: barData[key].color,
                             display: "flex",
                             flexDirection: "row",
                             justifyContent: "center",
                             alignItems: "center",
                             color: "black",
                             borderTopRightRadius: index === Object.keys(barData).length - 1 ? 5 : 0,
                             borderBottomRightRadius: index === Object.keys(barData).length - 1 ? 5 : 0,
                             borderTopLeftRadius: index === 0 ? 5 : 0,
                             borderBottomLeftRadius: index === 0 ? 5 : 0
                         }}>
                        <Typography sx={{fontWeight: 200}} color={"#000"}>{barData[key].nb}</Typography>
                        <Typography sx={{fontWeight: 500, ml: 1}} color={"#000"}>{barData[key].label}</Typography>
                    </Box>
                )
            })}
        </Box>
    )
}
